import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const heroImages = [
    'https://public.readdy.ai/ai/img_res/ad7e79821c205b9ee81fce2242f04844.jpg',
    'https://readdy.ai/api/search-image?query=Japanese%20female%20administrative%20scrivener%20professional%20working%20at%20modern%20office%20desk%20with%20documents%20and%20laptop%2C%20wearing%20business%20suit%2C%20confident%20smile%2C%20natural%20window%20lighting%2C%20clean%20organized%20workspace%2C%20professional%20business%20environment%2C%20warm%20welcoming%20atmosphere%2C%20high%20quality%20professional%20photography&width=1920&height=800&seq=hero2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Japanese%20business%20professional%20male%20consultant%20meeting%20with%20client%20in%20modern%20office%2C%20discussing%20documents%20across%20desk%2C%20professional%20attire%2C%20warm%20natural%20lighting%2C%20comfortable%20consultation%20room%2C%20trust%20and%20reliability%20atmosphere%2C%20clean%20minimalist%20interior%20design%2C%20high%20quality%20professional%20photography&width=1920&height=800&seq=hero3&orientation=landscape'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Add Schema.org JSON-LD for SEO
    const siteUrl = import.meta.env.VITE_SITE_URL || '';
    
    const professionalServiceSchema = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "おかやま行政書士事務所",
      "image": `${siteUrl}/og-image.jpg`,
      "description": "岡山市北区の行政書士事務所。建設業許可、会社設立、相続手続き、飲食店営業許可など幅広い行政手続きをサポート。",
      "url": siteUrl,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "○○町1-2-3",
        "addressLocality": "岡山市北区",
        "addressRegion": "岡山県",
        "postalCode": "700-0000",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 34.6617,
        "longitude": 133.9191
      },
      "telephone": "+81-86-012-3456",
      "faxNumber": "+81-86-012-3457",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      "priceRange": "初回相談無料",
      "areaServed": {
        "@type": "City",
        "name": "岡山市"
      },
      "founder": {
        "@type": "Person",
        "name": "岡山太郎",
        "jobTitle": "行政書士"
      }
    };

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(professionalServiceSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(faqSchema);
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const faqs = [
    {
      question: '行政書士とはどのような仕事をする専門家ですか?',
      answer: '行政書士は、官公署に提出する許認可申請書類の作成や提出代行、契約書などの権利義務・事実証明に関する書類作成を行う国家資格者です。建設業許可、飲食店営業許可、相続手続き、会社設立など、幅広い分野でお客様の事業や生活をサポートいたします。'
    },
    {
      question: '相談料や費用はどのくらいかかりますか?',
      answer: '初回相談は無料で承っております。業務内容により費用は異なりますが、事前にお見積もりを提示し、ご納得いただいてから業務を開始いたします。明朗会計を心がけており、追加料金が発生する場合は必ず事前にご相談させていただきます。'
    },
    {
      question: '岡山市以外の地域でも対応可能ですか?',
      answer: 'はい、岡山市を中心に、倉敷市、総社市、玉野市など岡山県内全域に対応しております。また、業務内容によっては県外のお客様にもオンライン相談や郵送でのやり取りで対応可能です。まずはお気軽にご相談ください。'
    },
    {
      question: '相談から手続き完了までどのくらいの期間がかかりますか?',
      answer: '手続きの種類により異なりますが、建設業許可で約2〜3ヶ月、会社設立で約2〜3週間、相続手続きで約3〜6ヶ月が目安となります。お急ぎの場合は可能な限り迅速に対応いたしますので、ご相談時にお申し付けください。'
    },
    {
      question: '土日や営業時間外の相談は可能ですか?',
      answer: '平日の営業時間内が基本となりますが、事前にご予約いただければ土日や夜間のご相談も可能です。お仕事でお忙しい方も安心してご利用いただけるよう、柔軟に対応させていただきます。'
    },
    {
      question: 'どのような書類を準備すればよいですか?',
      answer: '必要書類は手続きの内容により異なります。初回相談時に詳しくご説明いたしますので、まずは手ぶらでお越しいただいても構いません。ご相談内容が決まっている場合は、関連する書類をお持ちいただくとスムーズです。'
    }
  ];

  const testimonials = [
    {
      name: '山田 健一様',
      business: '建設業',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20male%20business%20owner%20in%20his%2050s%20wearing%20casual%20business%20attire%2C%20confident%20friendly%20smile%2C%20professional%20headshot%20portrait%2C%20natural%20lighting%2C%20clean%20white%20background%2C%20trustworthy%20appearance%2C%20high%20quality%20professional%20photography&width=400&height=400&seq=client1&orientation=squarish',
      comment: '建設業許可の申請でお世話になりました。複雑な手続きを丁寧に説明していただき、スムーズに許可を取得できました。岡山太郎先生の誠実な対応に感謝しています。'
    },
    {
      name: '佐藤 美咲様',
      business: '飲食店経営',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20female%20restaurant%20owner%20in%20her%2040s%20wearing%20elegant%20business%20casual%20attire%2C%20warm%20genuine%20smile%2C%20professional%20headshot%20portrait%2C%20natural%20soft%20lighting%2C%20clean%20white%20background%2C%20approachable%20friendly%20appearance%2C%20high%20quality%20professional%20photography&width=400&height=400&seq=client2&orientation=squarish',
      comment: '飲食店の開業に必要な許可申請を依頼しました。初めての開業で不安でしたが、親身になって相談に乗っていただき、無事にオープンできました。本当にありがとうございました。'
    },
    {
      name: '田中 誠様',
      business: '相続手続き',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20male%20professional%20in%20his%2060s%20wearing%20formal%20business%20suit%2C%20gentle%20reassuring%20smile%2C%20professional%20headshot%20portrait%2C%20natural%20lighting%2C%20clean%20white%20background%2C%20dignified%20trustworthy%20appearance%2C%20high%20quality%20professional%20photography&width=400&height=400&seq=client3&orientation=squarish',
      comment: '父の相続手続きでお世話になりました。複雑な手続きを一つ一つ丁寧に進めていただき、家族全員が安心できました。迅速かつ正確な対応に感謝しております。'
    },
    {
      name: '鈴木 由美様',
      business: '会社設立',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20female%20entrepreneur%20in%20her%2030s%20wearing%20modern%20business%20attire%2C%20bright%20confident%20smile%2C%20professional%20headshot%20portrait%2C%20natural%20lighting%2C%20clean%20white%20background%2C%20energetic%20professional%20appearance%2C%20high%20quality%20professional%20photography&width=400&height=400&seq=client4&orientation=squarish',
      comment: '会社設立の手続きを依頼しました。書類作成から登記まで、全てサポートしていただき、予定通りに会社を設立できました。今後も何かあればお願いしたいと思います。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section with Slider */}
      <section className="relative h-[500px] sm:h-[600px] md:h-[700px] lg:h-[800px] overflow-hidden">
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image}
              alt={`おかやま行政書士事務所 ${index + 1}`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/30"></div>
          </div>
        ))}
        
        <div className="relative h-full flex items-center">
          <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
                岡山市の行政書士なら<br />おかやま行政書士事務所
              </h1>
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white mb-3 sm:mb-4 leading-relaxed">
                建設業許可・会社設立・相続手続きなど<br />
                地域密着で誠実・迅速・確実にサポート
              </p>
              <p className="text-sm sm:text-base lg:text-lg text-white/90 mb-6 sm:mb-8 lg:mb-10">
                岡山市北区を拠点に、個人様から法人様まで幅広くサポート。初回相談無料で安心してご相談いただけます。
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a
                  href="tel:0860123456"
                  className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 text-white text-base sm:text-lg font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-fill mr-2 sm:mr-3 text-xl sm:text-2xl"></i>
                  086-012-3456
                </a>
                <a
                  href="#contact"
                  className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-white text-blue-600 text-base sm:text-lg font-semibold rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-fill mr-2 sm:mr-3 text-xl sm:text-2xl"></i>
                  お問い合わせ
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Slider Indicators */}
        <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2 sm:gap-3 z-10">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all cursor-pointer ${
                index === currentSlide ? 'bg-white w-6 sm:w-8' : 'bg-white/50'
              }`}
              aria-label={`スライド ${index + 1}`}
            ></button>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">主な取扱業務</h2>
            <p className="text-sm sm:text-base lg:text-lg text-gray-600 px-4">岡山市を中心に、幅広い行政手続きをサポートいたします</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              {
                icon: 'ri-building-line',
                title: '建設業許可申請',
                description: '新規申請から更新、業種追加まで、建設業に関する許認可手続きを総合的にサポート。岡山県内の建設業者様の事業拡大を支援します。',
                image: 'https://readdy.ai/api/search-image?query=Japanese%20construction%20workers%20at%20modern%20building%20site%20in%20Okayama%2C%20professional%20team%20working%20together%2C%20safety%20helmets%20and%20vests%2C%20clean%20organized%20construction%20environment%2C%20blue%20sky%20background%2C%20professional%20business%20photography%20style&width=600&height=400&seq=service1&orientation=landscape'
              },
              {
                icon: 'ri-store-line',
                title: '飲食店営業許可',
                description: '飲食店、喫茶店、バーなどの営業許可申請を代行。保健所との調整から開業までスムーズにサポートし、岡山市での開業を応援します。',
                image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20restaurant%20interior%20in%20Okayama%2C%20clean%20elegant%20dining%20space%20with%20wooden%20tables%20and%20chairs%2C%20warm%20ambient%20lighting%2C%20professional%20hospitality%20atmosphere%2C%20welcoming%20environment%2C%20high%20quality%20professional%20photography&width=600&height=400&seq=service2&orientation=landscape'
              },
              {
                icon: 'ri-file-text-line',
                title: '会社設立・法人手続き',
                description: '株式会社、合同会社の設立手続きから定款作成、登記申請まで一貫してサポート。岡山市での起業・創業を全面的にバックアップします。',
                image: 'https://readdy.ai/api/search-image?query=Japanese%20business%20professionals%20shaking%20hands%20in%20modern%20office%2C%20successful%20business%20partnership%20meeting%2C%20professional%20attire%2C%20bright%20natural%20lighting%2C%20clean%20corporate%20environment%2C%20trust%20and%20collaboration%20atmosphere%2C%20high%20quality%20professional%20photography&width=600&height=400&seq=service3&orientation=landscape'
              },
              {
                icon: 'ri-parent-line',
                title: '相続・遺言手続き',
                description: '相続手続き、遺言書作成、遺産分割協議書の作成など、相続に関する手続きを丁寧にサポート。ご家族の大切な財産を守ります。',
                image: 'https://readdy.ai/api/search-image?query=Japanese%20elderly%20couple%20consulting%20with%20professional%20advisor%20at%20comfortable%20office%2C%20warm%20reassuring%20atmosphere%2C%20natural%20lighting%2C%20discussing%20important%20documents%2C%20trust%20and%20care%20environment%2C%20high%20quality%20professional%20photography&width=600&height=400&seq=service4&orientation=landscape'
              },
              {
                icon: 'ri-car-line',
                title: '自動車登録・車庫証明',
                description: '自動車の名義変更、車庫証明の取得など、自動車に関する手続きを迅速に代行。岡山運輸支局での手続きもお任せください。',
                image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20car%20dealership%20showroom%20in%20Okayama%2C%20clean%20professional%20environment%20with%20new%20vehicles%20on%20display%2C%20bright%20natural%20lighting%2C%20organized%20professional%20space%2C%20high%20quality%20professional%20photography&width=600&height=400&seq=service5&orientation=landscape'
              },
              {
                icon: 'ri-passport-line',
                title: '在留資格・帰化申請',
                description: '外国人の方の在留資格申請、帰化申請、永住許可申請など、入管手続きをサポート。岡山で働く外国人の方を支援します。',
                image: 'https://readdy.ai/api/search-image?query=Diverse%20international%20business%20team%20working%20together%20in%20modern%20Japanese%20office%2C%20multicultural%20professional%20environment%2C%20collaborative%20atmosphere%2C%20natural%20lighting%2C%20inclusive%20workplace%2C%20high%20quality%20professional%20photography&width=600&height=400&seq=service6&orientation=landscape'
              }
            ].map((service, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                <div className="h-40 sm:h-48 overflow-hidden">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-5 sm:p-6">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                    <i className={`${service.icon} text-2xl sm:text-3xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{service.title}</h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{service.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8 sm:mt-10 lg:mt-12">
            <Link
              to="/services"
              className="inline-flex items-center px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 text-white text-base sm:text-lg font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              事業内容の詳細を見る
              <i className="ri-arrow-right-line ml-2 text-lg sm:text-xl"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-4">おかやま行政書士事務所が選ばれる理由</h2>
            <p className="text-sm sm:text-base lg:text-lg text-gray-600 px-4">岡山市で信頼される行政書士として、お客様に寄り添ったサービスを提供</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              {
                icon: 'ri-map-pin-line',
                title: '地域密着のサポート',
                description: '岡山市北区を拠点に、地域の特性を熟知した行政書士が対応。岡山県内の官公署との連携もスムーズで、迅速な手続きが可能です。'
              },
              {
                icon: 'ri-shield-check-line',
                title: '誠実・丁寧な対応',
                description: '初回相談無料で、お客様の状況を丁寧にヒアリング。専門用語を使わず分かりやすく説明し、安心して手続きを進めていただけます。'
              },
              {
                icon: 'ri-time-line',
                title: '迅速・確実な処理',
                description: '豊富な経験と知識で、複雑な手続きも迅速に対応。期限管理を徹底し、確実に手続きを完了させます。'
              }
            ].map((reason, index) => (
              <div key={index} className="text-center p-6 sm:p-8 bg-gray-50 rounded-xl">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                  <i className={`${reason.icon} text-3xl sm:text-4xl text-white`}></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">{reason.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Staff Introduction */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">代表者紹介</h2>
            <p className="text-sm sm:text-base lg:text-lg text-gray-600 px-4">お客様の信頼に応える、経験豊富な行政書士</p>
          </div>

          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="h-64 md:h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20male%20administrative%20scrivener%20in%20his%2040s%20wearing%20formal%20dark%20business%20suit%20with%20tie%2C%20confident%20trustworthy%20smile%2C%20professional%20studio%20portrait%2C%20clean%20white%20background%2C%20dignified%20professional%20appearance%2C%20warm%20natural%20lighting%2C%20high%20quality%20professional%20photography&width=600&height=700&seq=staff1&orientation=portrait"
                  alt="代表 岡山太郎"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6 sm:p-8 lg:p-10 flex flex-col justify-center">
                <div className="mb-4 sm:mb-6">
                  <p className="text-xs sm:text-sm text-blue-600 font-semibold mb-2">代表行政書士</p>
                  <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">岡山 太郎</h3>
                  <p className="text-sm sm:text-base text-gray-600">Taro Okayama</p>
                </div>
                <div className="space-y-3 sm:space-y-4 text-sm sm:text-base text-gray-700 leading-relaxed">
                  <p>
                    岡山市生まれ、岡山市育ち。地元岡山への深い愛着と、地域の皆様のお役に立ちたいという想いから、行政書士の道を選びました。
                  </p>
                  <p>
                    行政書士として、建設業許可、会社設立、相続手続きなど、幅広い分野で豊富な実績を積んでまいりました。お客様一人ひとりの状況に寄り添い、最適な解決策をご提案することを心がけております。
                  </p>
                  <p>
                    「誠実・迅速・確実」をモットーに、岡山市を中心とした地域の皆様の事業と生活をサポートしてまいります。どんな些細なことでも、お気軽にご相談ください。
                  </p>
                </div>
                <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-gray-200">
                  <h4 className="font-bold text-gray-900 mb-3 text-sm sm:text-base">資格・所属</h4>
                  <ul className="space-y-2 text-sm sm:text-base text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-check-line text-blue-600 mr-2 mt-1 flex-shrink-0"></i>
                      <span>行政書士（岡山県行政書士会所属）</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-blue-600 mr-2 mt-1 flex-shrink-0"></i>
                      <span>日本行政書士会連合会会員</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">お客様の声</h2>
            <p className="text-sm sm:text-base lg:text-lg text-gray-600 px-4">岡山市を中心に、多くのお客様にご利用いただいております</p>
          </div>

          <div className="grid sm:grid-cols-2 gap-6 sm:gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 sm:p-8 shadow-lg">
                <div className="flex items-start gap-4 sm:gap-6 mb-4 sm:mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover object-top flex-shrink-0"
                  />
                  <div>
                    <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-1">{testimonial.name}</h4>
                    <p className="text-xs sm:text-sm text-gray-600">{testimonial.business}</p>
                  </div>
                </div>
                <div className="flex gap-1 mb-3 sm:mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg sm:text-xl"></i>
                  ))}
                </div>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">{testimonial.comment}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">よくある質問</h2>
            <p className="text-sm sm:text-base lg:text-lg text-gray-600 px-4">岡山市の行政書士へのよくあるご質問にお答えします</p>
          </div>

          <div className="space-y-4 sm:space-y-6">
            {faqs.map((faq, index) => (
              <details key={index} className="bg-white rounded-xl shadow-lg overflow-hidden group">
                <summary className="px-5 sm:px-8 py-4 sm:py-6 cursor-pointer list-none flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <h3 className="text-sm sm:text-base lg:text-lg font-bold text-gray-900 pr-3 sm:pr-4">{faq.question}</h3>
                  <i className="ri-add-line text-xl sm:text-2xl text-blue-600 group-open:rotate-45 transition-transform flex-shrink-0"></i>
                </summary>
                <div className="px-5 sm:px-8 pb-4 sm:pb-6">
                  <p className="text-sm sm:text-base text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">お問い合わせ</h2>
            <p className="text-sm sm:text-base lg:text-lg text-gray-600 px-4">岡山市の行政書士へのご相談は、お電話またはフォームから</p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12">
            <div>
              <div className="bg-blue-50 rounded-2xl p-6 sm:p-8 mb-6 sm:mb-8">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">お電話でのお問い合わせ</h3>
                <div className="space-y-4 sm:space-y-6">
                  <div className="flex items-center gap-3 sm:gap-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-fill text-xl sm:text-2xl text-white"></i>
                    </div>
                    <div>
                      <p className="text-xs sm:text-sm text-gray-600 mb-1">電話番号</p>
                      <a href="tel:0860123456" className="text-xl sm:text-2xl font-bold text-blue-600 hover:text-blue-700 cursor-pointer whitespace-nowrap">
                        086-012-3456
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 sm:gap-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-printer-fill text-xl sm:text-2xl text-white"></i>
                    </div>
                    <div>
                      <p className="text-xs sm:text-sm text-gray-600 mb-1">FAX</p>
                      <p className="text-lg sm:text-xl font-bold text-gray-900 whitespace-nowrap">086-012-3457</p>
                    </div>
                  </div>
                  <div className="pt-3 sm:pt-4 border-t border-blue-200">
                    <p className="text-xs sm:text-sm text-gray-600 mb-2">営業時間</p>
                    <p className="text-base sm:text-lg font-semibold text-gray-900">9:00 〜 18:00</p>
                    <p className="text-xs sm:text-sm text-gray-600 mt-1">定休日：日曜日・祝日</p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-2xl p-6 sm:p-8">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">アクセス</h3>
                <div className="space-y-3 text-sm sm:text-base text-gray-700">
                  <div className="flex items-start gap-3">
                    <i className="ri-map-pin-fill text-blue-600 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
                    <div>
                      <p className="font-semibold mb-1">所在地</p>
                      <p>〒700-0000<br />岡山市北区○○町1-2-3</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-train-fill text-blue-600 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
                    <div>
                      <p className="font-semibold mb-1">交通アクセス</p>
                      <p>JR岡山駅より徒歩10分<br />駐車場完備</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">お問い合わせフォーム</h3>
              <form id="contact-form" data-readdy-form className="space-y-4 sm:space-y-6" onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const data = new URLSearchParams();
                
                formData.forEach((value, key) => {
                  if (key === 'subject') {
                    const select = form.querySelector(`select[name="${key}"]`) as HTMLSelectElement;
                    data.append(key, select.options[select.selectedIndex].text);
                  } else {
                    data.append(key, value.toString());
                  }
                });

                try {
                  const response = await fetch('https://readdy.ai/api/form/d4j8017b8l4gait66j70', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: data.toString()
                  });

                  if (response.ok) {
                    alert('お問い合わせを送信しました。ありがとうございます。');
                    form.reset();
                  } else {
                    alert('送信に失敗しました。もう一度お試しください。');
                  }
                } catch (error) {
                  alert('送信に失敗しました。もう一度お試しください。');
                }
              }}>
                <div>
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-2">
                    お名前 <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm sm:text-base"
                    placeholder="山田 太郎"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
                    メールアドレス <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm sm:text-base"
                    placeholder="example@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-900 mb-2">
                    電話番号
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm sm:text-base"
                    placeholder="090-1234-5678"
                  />
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-semibold text-gray-900 mb-2">
                    お問い合わせ内容 <span className="text-red-600">*</span>
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    required
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm sm:text-base appearance-none bg-white cursor-pointer"
                  >
                    <option value="">選択してください</option>
                    <option value="建設業許可">建設業許可</option>
                    <option value="飲食店営業許可">飲食店営業許可</option>
                    <option value="会社設立">会社設立</option>
                    <option value="相続手続き">相続手続き</option>
                    <option value="自動車登録">自動車登録</option>
                    <option value="在留資格">在留資格</option>
                    <option value="その他">その他</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-900 mb-2">
                    詳細内容 <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={6}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm sm:text-base resize-none"
                    placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                  ></textarea>
                  <p className="text-xs sm:text-sm text-gray-500 mt-2">500文字以内でご入力ください</p>
                </div>

                <button
                  type="submit"
                  className="w-full px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 text-white text-base sm:text-lg font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  送信する
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 w-11 h-11 sm:w-12 sm:h-12 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-all flex items-center justify-center cursor-pointer z-50"
          aria-label="ページトップへ"
        >
          <i className="ri-arrow-up-line text-xl sm:text-2xl"></i>
        </button>
      )}

      <Footer />
    </div>
  );
}